export default function (s: string) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}
